import { useEffect, useState } from "react";
import NocService from "./NocService";
import ApiClient from "../http/ApiClient";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, } from "react-bootstrap";
import ModalComp from "../common/ModalComp";
import NocForm from "./NocForm";
import ApprovalPage from "./ApprovalPage";

const HistoryNoc = (props) => {
  const [formValues, setFormValues] = useState({});
  const [nocData, setNocData] = useState([]);
  const [nocFormModalShow, setNocFormModalShow] = useState(false);
  const [applicationId, setApplicationId] = useState({});
  const [nocFormViewShow, setNocFormViewShow] = useState(false);
  const nocFormModalShowClose = () => { setNocFormModalShow(false) }
  const nocFormViewShowClose = () => { setNocFormViewShow(false) }
  useEffect(() => {
    getData();
  }, [props.nocId]);


  const getData = () => {
    NocService.historyNoc(props.nocId).then((result) => {
      setNocData(result);
    })
  }

  //const dataToDisplay = nocData.slice(0, -1);

  return (
    < >



      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">NOC Approval workflow</h5>

                <div className="row g-12">
                  <table class="table table-striped">
                    <tr border="1">
                      <th>Application No</th>
                      <th>Name Of Employee</th>
                      <th>Department</th>
                      <th>Remarks</th>
                      <th>Date and Time</th>
                      <th>Status</th>

                    </tr>
                    {nocData && nocData.map((row, index) => (
                      (row.actDateTime !== null) ?
                        <tr>
                          <td>{row.nocNo}</td>
                          <td>{row.name}</td>
                          <td>{row.deptName}</td>
                          <td>{row.remarks}</td>
                          <td>{row.actDateTime}</td>
                          <td>{row.actDesc}</td>
                        </tr> : <></>
                    )
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default HistoryNoc;
